module.exports = __webpack_public_path__ + "favicon.ico";


/*****************
 ** WEBPACK FOOTER
 ** ../favicon.ico
 ** module id = 637
 ** module chunks = 0 1 2 4 5 6 7 8
 **/